import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RefundMethodsListSkeleton = () => (
  <Styles.Container>
    <Skeleton variant="circular" width={300} height={300} />
    <Styles.RowsContainer>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width="100%" height={40} />
      ))}
    </Styles.RowsContainer>
  </Styles.Container>
)

export default RefundMethodsListSkeleton
